import * as tslib_1 from "tslib";
import React from 'react';
import classnames from 'classnames';
import { useFlag } from '../../redux/flags/hooks/useFlag';
import BaseViewer from './Base';
import commentsTheme from '../Themes/Viewer/comments.scss';
var CommentViewer = function (props) {
    var v2 = useFlag('comment_v2');
    return (React.createElement("div", { className: classnames('da-editor-comments', v2 && 'da-editor-comments-v2') },
        React.createElement(BaseViewer, tslib_1.__assign({ theme: commentsTheme, showMediaAlwaysSmall: true, fixedParagraph: false }, props))));
};
export default CommentViewer;
//# sourceMappingURL=Comment.js.map